module.exports = __webpack_public_path__ + "static/media/home.cf135e93.svg";